<!--
  lovi
  手机 2020-1-8
-->
<template>
  <div class="w100 childRoute-wrapper">
    <van-nav-bar
      :class="{ noShadow: subTitleFlag }"
      :title="title"
      :fixed="true"
      left-arrow
      @click-left="_back"
    />
    <div class="scroll-wrapper logReg-field">
      <h3 v-if="subTitleFlag">{{ $t("common.bindMobilePhone") }}</h3>
      <ul>
        <li>
          <van-cell-group>
            <van-field
              class="van-field-phone"
              label="+63"
              clearable
              :readonly="readonly"
              left-icon="icon-tel"
              v-model="phone"
              type="tel"
              :error="error.phone ? true : false"
              :maxlength="telMax"
              :formatter="_phoneFormat"
              @input="changePhone"
              :placeholder="$t('common.enterMobile')"
            />
          </van-cell-group>
        </li>
        <li>
          <van-cell-group>
            <van-field
              class="van-field-code"
              clearable
              left-icon="icon-lock"
              v-model="code"
              :error="error.code ? true : false"
              @input="verifyCode"
              :placeholder="$t('common.enterVerificationCode')"
            >
              <div slot="button">
                <van-count-down
                  class="text-orange"
                  v-if="countDownFlag"
                  :time="60000"
                  :format="$t('common.remaining') + 'ss s'"
                  @finish="finished"
                />
                <span v-else class="text-orange" @click="sendMobile">
                  {{
                    againFlag ? $t("common.getAgain") : $t("common.getItNow")
                  }}
                </span>
              </div>
            </van-field>
          </van-cell-group>
        </li>
        <li>
          <van-button
            round
            type="primary"
            block
            :loading="btnLoading"
            @click="submit"
          >
            {{ type == 6 ? $t("common.verification") : $t("common.confirm") }}
          </van-button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import * as validate from "@/commonJs/validate.js";
export default {
  name: "mobile",
  meta: {
    power: false,
    service: false // 客服
  },
  components: {},
  data() {
    return {
      flag: "", //路由传参
      title: "",
      routeData: {}, //路由数据
      btnLoading: false,
      readonly: false,

      telMax: 13,
      phone: "",
      code: "",
      error: {
        phone: false,
        code: false
      },
      countDownFlag: false, // 倒计时
      againFlag: false, // 重新获取短信验证码
      type: 0,

      subTitleFlag: false //二级标题
    };
  },
  created() {
    this.initialize();
  },
  mounted() {},
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods: {
    initialize(str) {
      // 页面初始化
      let vm = this;
      vm.flag = vm.$route.query.flag;
      if (vm.flag == "reg") {
        if (_.isEmpty(vm.$route.params)) {
          // 刷新页面要返回
          vm._back();
        } else {
          vm.routeData = vm.$route.params;
        }
        console.log("routeData", vm.routeData);
      }
      if (vm.flag == "reg") {
        // 注册
        vm.type = 2;
        vm.subTitleFlag = true;
      }
      if (vm.flag == "forgetPsd") {
        vm.title = vm.$t("common.forgetPassword");
        vm.type = 3;
      }
      if (vm.flag == "edit") {
        vm.title = vm.$t("common.modifyBoundMobile");
        vm.type = 6;
      }
      if (str == "changeBind") {
        vm.title = vm.$t("common.changeBoundMobile");
        vm.type = 2;
        vm.code = "";
        vm.countDownFlag = false; // 倒计时
        vm.againFlag = false; // 重新获取短信验证码
      }
      if (vm.userInfo.phone && (vm.type == 3 || vm.type == 6)) {
        // 忘记密码或者修改密码
        vm.phone = vm._phoneFormat(vm.userInfo.phone);
        vm.readonly = true;
      } else {
        vm.phone = "";
        vm.readonly = false;
      }
    },
    changePhone(value) {
      // 手机
      console.log("phone", value);
      let firstStr = (value + "").substr(0, 1);
      if (firstStr == "0") {
        //如果第一个字符是0，则输入框最多输入13位
        this.telMax1 = 13;
      } else {
        //否则输入框最多输入12位
        this.telMax1 = 12;
      }
      let phone = value.replace(/\s/g, "");
      this.error.phone = validate.validateMobile(phone);
    },
    verifyCode() {
      // 验证码
      this.error.code = validate.validateCode(this.code);
    },
    finished() {
      // 倒计时结束
      this.countDownFlag = false;
      this.againFlag = true;
    },
    sendMobile() {
      // 获取手机验证码
      let vm = this;
      if (vm.phone == "") {
        vm.$toast(vm.$t("common.enterMobile"));
        return false;
      }
      console.log(vm.error);
      if (vm.error.phone) {
        vm.$toast(vm.error.phone);
        return false;
      }
      let params = {};
      // 号码处理先删除空格转换成数字再补0
      params.phone = "0" + Number(vm.phone.replace(/\s/g, ""));
      params.type = vm.type;
      vm.$post("/app/captcha/sendMobile", params, {
        alert: true,
        loading: true
      }).then(res => {
        console.log("sendMobile", res);
        if (res.code == 0) {
          vm.countDownFlag = true;
        } else {
          vm.$toast(res.msg);
        }
      });
    },
    submit() {
      // 提交
      let vm = this;
      if (vm.phone == "") {
        vm.$toast(vm.$t("common.enterMobile"));
        return false;
      }
      if (vm.code == "") {
        vm.$toast(vm.$t("common.enterVerificationCode"));
        return false;
      }
      for (let key in vm.error) {
        if (vm.error[key]) {
          vm.$toast(vm.error[key]);
          return false;
        }
      }

      let params = {};
      // 号码处理先删除空格转换成数字再补0
      params.phone = "0" + Number(vm.phone.replace(/\s/g, ""));
      params.code = vm.code;
      params.type = vm.type;
      if (vm.flag == "reg" || vm.type == 3 || vm.type == 6) {
        vm.validateCode(params);
      }
      if (vm.flag == "edit" && vm.type == 2) {
        // 修改手机号
        vm.mobileModify(params);
      }
    },
    validateCode(data) {
      // 验证绑定手机号
      let vm = this;
      vm.btnLoading = true;
      vm.$post("/app/captcha/validateCode", data, { alert: true }).then(res => {
        console.log("validateCode", res);
        vm.btnLoading = false;
        let params = {};
        params.username = vm.routeData.username;
        params.password = vm.routeData.password;
        params.mark = vm.routeData.mark;
        params.nickname = vm.routeData.nickname;
        params.Invitees_id = vm.routeData.Invitees_id;
        params.phone = data.phone;
        params.code = data.code;
        if (res.code == 0) {
          if (vm.flag == "reg") {
            // 设置支付密码
            vm.$router.push({
              path: "/payPsd",
              name: "payPsd",
              query: { flag: "reg" },
              params: params
            });
          } else if (vm.type == 3) {
            // 设置登录密码
            let routeData = {};
            routeData.phone = data.phone;
            routeData.code = data.code;
            vm.$router.replace({
              path: "/setPsd",
              name: "setPsd",
              params: routeData
            });
          } else if (vm.type == 6) {
            vm.initialize("changeBind");
          }
        } else if (res.code == 40105) {
          // 40105 返回手机号已经被其他账户绑定
        } else if (res.code == 40126) {
          // 40126 返回手机号已经绑定 但是没有设置账号与支付密码
        } else if (res.code == 40127) {
          // 40127 返回手机号已经绑定 但是没有设置账号 有设置过支付密码
        } else {
          vm.$toast(res.msg);
        }
      });
    },
    mobileModify(data) {
      // 修改手机号
      let vm = this;
      vm.btnLoading = true;
      vm.$post("/app/user/mobileModify", data, { alert: true }).then(res => {
        console.log("mobileModify", res);
        vm.btnLoading = false;
        vm.$toast(res.msg);
        if (res.code == 0) {
          vm.$store.dispatch("GET_USER_INFO");
          vm._back();
        }
      });
    }
  },
  watch: {
    userInfo: {
      handler(obj) {
        if (obj.phone) {
          this.initialize();
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="less" scoped>
.text-gray {
  margin-top: 10px;
  text-align: center;
  font-size: 12px;
}
</style>
